<template>
  <a-config-provider :locale="zhCN">
    <el-config-provider :locale="locale">
      <div class="main-content">
        <!-- 公告弹窗 -->
        <el-dialog v-model="noticeDialog.visible" width="600px" :close-on-click-modal="false"
          :close-on-press-escape="false" :show-close="false">
          <div class="notice-content">
            <h3 class="notice-title">{{ noticeDialog.title }}</h3>
            <div class="notice-body" v-html="noticeDialog.content"></div>
          </div>
          <template #footer>
            <span class="dialog-footer">
              <el-button type="primary" @click="closeNotice">我知道了</el-button>
            </span>
          </template>
        </el-dialog>

        <!-- 路由页面 -->
        <router-view />
      </div>
    </el-config-provider>
  </a-config-provider>
</template>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.main-content {
  flex: 1;
  background-color: rgb(242 242 242);
  height: 100vh;
  padding-left: 0 !important;
  overflow: auto;
}

.warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}

.success-row {
  --el-table-tr-bg-color: var(--el-color-success-light-9);
}

.iconfont {
  font-size: 1.25rem !important;
}

::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
  border: 3px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.notice-content {
  .notice-title {
    color: #333;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    text-align: center;
  }

  .notice-body {
    color: #666;
    line-height: 1.6;

    p {
      margin-bottom: 10px;
    }

    ul {
      padding-left: 20px;

      li {
        margin-bottom: 5px;
      }
    }
  }
}

.dialog-footer {
  text-align: center;
}
</style>

<script>
import { ElConfigProvider, ElDialog, ElButton } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import zhCN from 'ant-design-vue/es/locale/zh_CN'

export default {
  data() {
    return {
      isNavOpen: true,
      locale: zhCn,
      zhCN: zhCN,
      noticeDialog: {
        visible: false,
        title: '系统公告',
        content: `
          <p>请严格遵守您所在国家/地区的法律法规，严禁利用易售SUP系统售卖任何被您所在国家/地区禁止销售的产品和服务，严禁利用易售SUP系统从事任何违法违规的业务，否则，易售SUP官方有权封禁您的授权。</p>
            <p>TG唯一官方客服：@yishousup</p>
            <p>TG通知群：https://t.me/yishougroup</p>
            <p>安装教程：https://boke.yishou.shop/index.php/archives/314/</p>
          <p><strong>代理优惠政策：</strong></p>
          <ul>
            <li>预存300或花费88购买代理，享受8折授权</li>
            <li>预存500或花费288购买代理，享受7折授权</li>
            <li>预存1000或花费399购买代理，享受6折授权</li>
            <li>预存1500或花费499购买代理，享受5折授权</li>
            <li>预存2000或花费599购买代理，享受4折授权</li>
            <li>2折代理不对外开放</li>
          </ul>
          <p>请联系客服预存，预存仅支持USDT支付</p>
          <p>建议联系各个授权商购买授权，客服仅支持USDT支付</p>
          <p>点击右上角寻找授权商即可联系各个官方认证授权商</p>
          <p>所有代理最低可以给予用户9折优惠授权，不允许更低价格授权</p>
        `
      }
    }
  },
  components: {
    ElConfigProvider,
    ElDialog,
    ElButton
  },
  methods: {
    checkAndShowNotice() {
      // 检查 sessionStorage 中是否已记录用户已查看公告
      const noticeShown = sessionStorage.getItem('noticeShown');
      let pathname = location.pathname.toLowerCase()
      // 如果没有记录，则显示公告
      if (!noticeShown && pathname.indexOf("/notice") == -1) {
        this.noticeDialog.visible = true;
      }
    },

    showNoticeDialog() {
      this.noticeDialog.visible = true;
    },

    closeNotice() {
      // 关闭公告弹窗
      this.noticeDialog.visible = false;

      // 在 sessionStorage 中记录用户已查看公告
      sessionStorage.setItem('noticeShown', 'true');
    }
  },
  mounted() {
    // 页面加载完成后检查是否需要显示公告
    this.$nextTick(() => {
      this.checkAndShowNotice();
    });

    window.addEventListener('show-notice-dialog', this.showNoticeDialog);
  },
  beforeUnmount() {
    window.removeEventListener('show-notice-dialog', this.showNoticeDialog);
  }
}
</script>